import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: Array<any>, callback: any, q: string): any {
    return value.filter(o => callback(o, q));
  }

}



// WEBPACK FOOTER //
// ./src/app/vqutils/filter.pipe.ts